import React from 'react';
import ReactDOM from 'react-dom';
import {RecaptchaVerifier, ConfirmationResult} from '@firebase/auth-types';
import {StylesProvider} from '@material-ui/core/styles';

import App from './App';

import * as serviceWorker from './serviceWorker';

import './localization';
import './index.css';

declare global {

  interface JavascriptInterface {
    callHandler(name: String, ...args: any[]): void
  }
  const flutter_inappbrowser: JavascriptInterface;

  interface Window {
    recaptchaVerifier: RecaptchaVerifier
    recaptchaWidgetId: number
    confirmationResult: ConfirmationResult
  }
}


ReactDOM.render(
  <StylesProvider injectFirst>
    <App />
  </StylesProvider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about services workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
